export enum RateShopStatus {
  CREATED = 'CREATED',
  IN_PROGRESS = 'IN_PROGRESS',
  RATED = 'RATED',
  COMPLETED = 'COMPLETED',
  ERROR = 'ERROR',
}
